import type { ComponentProps } from 'react';
import { Text } from 'braid-design-system';
import MetaLinkRenderer from '../MetaLinkRenderer/MetaLinkRenderer';

type TShimArrayWith = (
  array: any[],
  shim: string,
  fn?: (arg: any, index: number) => React.ReactNode,
) => React.ReactNode[];

const shimArrayWith: TShimArrayWith = (array, shim = '', fn = (item) => item) =>
  array?.reduce(
    (accum, item, index) =>
      accum.length === 0
        ? [...accum, fn(item, index)]
        : [...accum, shim, fn(item, index)],
    [],
  );

const LocationLink = ({
  unifiedLocation,
  rel,
}: {
  unifiedLocation: Array<ComponentProps<typeof MetaLinkRenderer>['item']>;
  rel?: string;
}) => (
  <Text size="small">
    {shimArrayWith(unifiedLocation, ', ', (item) => (
      <MetaLinkRenderer
        item={item}
        key={item.name}
        type="location"
        shouldUseNormalisedCompanyName
        rel={rel}
        disabledLink
      />
    ))}
  </Text>
);

export default LocationLink;
